import { FC } from 'react'
import { AccordionContent, AccordionHeading } from '@yuno/sdk-web-core/dist/ui'
import {
  Heading,
  Instructions,
  LeftPanelFooter,
  MerchantLogo,
  OrderAccordion,
  OrderContainer,
  OrderHeader,
  OrderTotalPurchase,
  OrderTotalPurchaseContainer,
  TitleBlock,
} from './order.styled'
import {
  OrderDetailContent,
  OrderDetailPurchase,
  OrderDetailTitle,
  OrderTotal,
} from './order-components'
import { useOrder } from './use-order'
import { ORDER_DETAILS_ID, ORDER_ID } from './order.constants'
import { useTranslation } from 'react-i18next'
import { useDescription } from '../../hooks'
import { queryClient } from '../../state'
import { CheckoutInfo } from '../../types'
import { LanguageSelector } from '../language-selector'
import { getMerchantLogo } from '../payment-checkout/payment-methods/payment-methods.utils'

export const Order: FC = () => {
  const {
    onChange,
    order,
    airline,
    totalDue,
    currency,
    hasProducts,
  } = useOrder()
  const { t } = useTranslation()
  const { description } = useDescription()
  const checkoutInfo = queryClient.getQueryData<CheckoutInfo>(['checkout-info'])
  const merchantImage = getMerchantLogo(checkoutInfo?.payment_link.style ?? null)
    || checkoutInfo?.payment_link.merchant_image

  return (
    <OrderContainer>
      <OrderHeader>
        {merchantImage && <MerchantLogo src={merchantImage} alt="merchant logo" />}
        <TitleBlock>
          <Heading>{t('Review your order')}</Heading>
          {description && <Instructions>{description}</Instructions>}
        </TitleBlock>
      </OrderHeader>
      <OrderTotalPurchase hasProducts={hasProducts}>
        <OrderTotalPurchaseContainer hasProducts={hasProducts}>
          <OrderTotal
            totalDue={totalDue}
            currency={currency}
            hasProducts={hasProducts}
          />
          {airline?.legs && <OrderDetailPurchase items={airline.legs} />}
        </OrderTotalPurchaseContainer>
      </OrderTotalPurchase>
      {order?.items && (
        <OrderAccordion onChange={onChange}>
          <AccordionHeading
            id={ORDER_ID}
            ariaControls={ORDER_DETAILS_ID}
            open={false}
          >
            <OrderDetailTitle />
          </AccordionHeading>
          <AccordionContent id={ORDER_DETAILS_ID} ariaLabelledBy={ORDER_ID}>
            {order.items.map((item, index) => (
              <OrderDetailContent key={index} {...item} />
            ))}
          </AccordionContent>
        </OrderAccordion>
      )}
      <LeftPanelFooter>
        <LanguageSelector />
      </LeftPanelFooter>
    </OrderContainer>
  )
}
